import * as actionTypes from "./actionTypes";
import { IInvestorSearchParams } from "../../interfaces/investor";

export const setAdvancedInvestorSearchParams = (
  values: IInvestorSearchParams,
) => {
  return {
    type: actionTypes.SET_ADVANCED_INVESTOR_SEARCH_PARAMS,
    payload: values,
  };
};
